/* ============================================================
   OUR STORY — minimal entrance
   Single CSS-driven fade-in for the heading on load.
   No GSAP. No ScrollTrigger. No scrub animations.
   ============================================================ */

(function () {
  'use strict';

  function reveal() {
    var header = document.querySelector('#ks-story-full .ks-sf-header');
    if (!header) return;
    // Next frame so the initial (opacity:0) state is committed first,
    // ensuring the 200ms transition actually plays.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        header.classList.add('is-in');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();
